export const useKftApiPagination = () => {
  const currentPage = ref(1)
  const objectsPerPage = ref(10)
  const totalPages = ref(1)
  const totalObjects = ref(0)
  const currentPageCount = ref(0)

  const goToNextPage = () => {
    if (currentPage.value < totalPages.value) {
      currentPage.value++
    }
  }

  const goToPrevPage = () => {
    if (currentPage.value > 1) {
      currentPage.value--
    }
  }

  const goToPage = (page: number) => {
    if (page > 0 && page <= totalPages.value && page !== currentPage.value) {
      currentPage.value = page
    }
  }

  return {
    totalPages,
    totalObjects,
    currentPageCount,
    currentPage: readonly(currentPage),
    objectsPerPage: readonly(objectsPerPage),
    goToNextPage,
    goToPrevPage,
    goToPage,
  }
}
